import { default as dayjsImport } from 'dayjs'
import type { Dayjs } from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import duration from 'dayjs/plugin/duration'
import isoWeek from 'dayjs/plugin/isoWeek'
import type { IPP_SUPPORTED_LOCALE } from '../intl'

dayjsImport.extend(advancedFormat)
dayjsImport.extend(utc)
dayjsImport.extend(timezone)
dayjsImport.extend(duration)
dayjsImport.extend(relativeTime)
dayjsImport.extend(localizedFormat)
dayjsImport.extend(customParseFormat)
dayjsImport.extend(isBetween)
dayjsImport.extend(quarterOfYear)
dayjsImport.extend(isoWeek)

export const dayjs = dayjsImport
export { Dayjs }

export const DAYJS_LOCALE_MAPPING: Record<IPP_SUPPORTED_LOCALE, string> = {
  ['es-ES']: 'es',
  ['en-US']: 'en',
  ['fr-FR']: 'fr',
} as const
